import { styled } from '@mui/system';
import { colors } from '../styles/globalStyles';
import {Button, Typography} from '@mui/material';
import {Link, useNavigate} from 'react-router-dom';
import {ReactComponent as LeftArrow} from "../images/left_arrow.svg";
import React, {useEffect, useState} from "react";
import {getUserData} from "../api/auth";
import { selectedLanguageAtom } from '../recoil/atoms/languageAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import textData from '../data/data.json';

const PageWrapper = styled('div')({
    background: colors.white,
    padding: '2px 17px 17px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '0 1 auto',
    gap: 17,
    minHeight: '100svh',
    maxWidth: '390px',
    margin: '0 auto',
    position: 'relative',
});

const ContentWrapper = styled('div')({
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
});

const Title = styled(Typography)({
    lineHeight: 1,
    letterSpacing: '0.01rem',
    fontWeight: 800,
    fontSize: 30,
    textAlign: 'center',
    color: colors.darkBlue,
    marginLeft: 'auto',
    marginRight: 'auto',
});

const CustomButton = styled(Link)({
    background: colors.transparentWhite,
    borderRadius: 23,
    color: 'white',
    padding: '18px 8px',
    flex: 1,
    textDecoration: 'none',

    '&.light': {
        background: colors.main,
        color: colors.white,
    },
});

const ButtonStyled = styled(Button)({
    position: 'absolute',
    top: 10,
});

const TrialEndPage = () => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { trialEndPage } = textData[selectedLanguage];
    const navigate = useNavigate();
    const [isLeader, setIsLeader] = useState(false);
    const setLanguage = useSetRecoilState(selectedLanguageAtom);

    useEffect(() => {
        getUserData('', '', true)
            .then((user) => {
                setIsLeader(user.isLeader);
                setLanguage(user.language);
                localStorage.setItem('language', user.language);
            })
            .catch((error) => {
                console.error('Ошибка получения данных пользователя', error);
            });
    }, []);

    return (
        <PageWrapper>
            {isLeader && (
                <ButtonStyled
                    variant="coloredLight"
                    sx={{
                        color: colors.darkBlue,
                        '&:hover': { backgroundColor: colors.transparentMain },
                    }}
                    startIcon={<LeftArrow fill={colors.darkBlue} />}
                    onClick={() => navigate('/admin')}
                >
                    {trialEndPage.backButton.text}
                </ButtonStyled>
            )}
            <ContentWrapper>
                <Title>{trialEndPage.content.title}</Title>
                <Typography variant={'body1'} dangerouslySetInnerHTML={{ __html: trialEndPage.content.description }} />
                <CustomButton className={'light'} to={'https://t.me/DmitryShiryaev'}>
                    <Typography variant={'body1'} sx={{ color: 'white' }}>
                        {trialEndPage.content.accessButton.text}
                    </Typography>
                </CustomButton>
            </ContentWrapper>
        </PageWrapper>
    );
};

export default TrialEndPage;
